import { createFileRoute } from "@tanstack/react-router";
import { buildHref } from "@softmax/web-addresses";
import { getPolicy } from "@/features/policies/records";
import { PolicyContent } from "@/features/policies";
import { NavigationReady } from "@softmax/web-features/navigation/markers";

export const Route = createFileRoute("/_site/policies/$policyId")({
  loader: ({ params, location, abortController }) =>
    getPolicy({
      signal: abortController.signal,
      data: {
        identifier: params.policyId,
        kind: "policy",
        search: location.searchStr,
      },
    }),
  component: PolicyPage,
});

function PolicyPage() {
  const policy = Route.useLoaderData();

  return (
    <>
      <NavigationReady
        stage="content"
        path={buildHref({
          name: "policy",
          policyName: policy.selectedVersion.name,
          version:
            policy.selectedVersion.id === policy.latestVersion.id
              ? null
              : policy.selectedVersion.version,
        })}
      />
      <PolicyContent key={policy.selectedVersion.id} policy={policy} />
    </>
  );
}
